import { useQuery } from 'react-query';
import { client } from '../util/client';

export const avatarMimeType = 'image/jpeg';

export type FileResponse = {
  id: string;
  mimeType: string;
  // Null when the CDN base URL isn't configured server-side (ALDO-2762); the
  // consumer falls back to the gender-default avatar.
  url: string | null;
};

export const useFile = (id?: string) =>
  useQuery<FileResponse>(
    ['file', id],
    async () => {
      const res = await client.get(`/file/${id}`);
      return res.data;
    },
    {
      enabled: !!id,
    },
  );
